export enum StatesConstants {
  PUB = 'PUB',
  ESB = 'ESB',
  OBS = 'OBS'
}
